import React, {useContext, useReducer} from 'react'
import UserContext from './userProvider'
import { Action, KeyValuePayload } from '../../model'
import access from 'src/utils/localAccess'


const AppInfoContext = React.createContext<any>(null)
const initialState = {
    authToken: '', onboardingType: 'new-user', onboardingProcessStatus: {}, 
    otpPhoneNo: '', theme: {}, institutionData: {}, hostName: '', onboardingSideInfo: [], 
    termsAndConditions_Privacy: {}, alias: '', defaultSettingsView: ''
}

const AppInfoReducer = (state: any, action: Action<KeyValuePayload>) => {
    switch(action.type){
        case "set-property": 
            return { ...state, [action.payload.key]: action.payload.value }
        case 'clear-data': 
            return { 
                ...initialState, theme: state.theme, institutionData: state.institutionData,
                onboardingSideInfo: state.onboardingSideInfo, termsAndConditions_Privacy: state.termsAndConditions_Privacy,
                hostName: state.hostName, alias: state.alias
            }
    }
}

export const AppInfoProvider = (props: any) => {
    const {clearUserData, recoverUserData} = useContext(UserContext)
    const [state, dispatch] = useReducer(AppInfoReducer, {
      ...initialState
    })

    async function setInfoProperty (key: string, value: any) {
        //localStorage.setItem(key, JSON.stringify(value))
        let isString = typeof(value) === 'string' ? true : false
        let isNumber = typeof(value) === 'number' ? true : false
        localStorage.setItem(key, isString ? value : isNumber ? String(value) : JSON.stringify(value))
        await dispatch({type: "set-property", payload: {key, value}})
    }

    async function recoverAppData (data?: Array<string>) {
        for (let item of Object.keys(initialState)) {
            if (data?.length) {
                if (!data.includes(item)) continue
            }
            let retrievedData = await localStorage.getItem(item)!
            retrievedData = (['null', 'undefined', 'NaN'].includes(retrievedData) ? state[item] : ['number', 'string'].includes(typeof state[item]) ? retrievedData : JSON.parse(retrievedData))
            await setInfoProperty(item, typeof state[item] === 'number' ? Number(retrievedData) : retrievedData)
        }
    }

    async function clearAppData () {
        await dispatch({type: "clear-data", payload: {key: '', value: ''}})
    }

    async function recoverStatesData () {
        await Promise.all([
            recoverAppData(), recoverUserData()
        ])
    }

    async function logout () {
        await Promise.allSettled([
            localStorage.clear(),
            clearAppData(), 
            clearUserData(), 
            localStorage.setItem('theme', JSON.stringify(state.theme)),
            localStorage.setItem('institutionData', JSON.stringify(state.institutionData)),
            localStorage.setItem('onboardingSideInfo', JSON.stringify(state.onboardingSideInfo)),
            localStorage.setItem('termsAndConditions_Privacy', JSON.stringify(state.termsAndConditions_Privacy)),
            localStorage.setItem('hostName', state.hostName),
            localStorage.setItem('alias', state.alias) // TODO: to be removed as it is just for testing
        ])

        if (access.getNavigationAccess()) access.getNavigationAccess()('/login')
    }
  

    const stateActions = {
       setInfoProperty,
       recoverStatesData,
       recoverAppData,
       clearAppData,
       logout
    }

    return (
        <AppInfoContext.Provider value={{info: state, ...stateActions}} >
            {props.children}
        </AppInfoContext.Provider>
    )
}

export default AppInfoContext